import actionTypes from './actionTypes'

const onboardingActivityActions = {

	createLessonSuccess(payload) {
		return {
			type: actionTypes.ONBOARDING_ACTIVITY_CREATE_LESSON_SUCCESS,
			payload,
		}
	},

	createLessonFailed(error) {
		return {
			type: actionTypes.ONBOARDING_ACTIVITY_CREATE_LESSON_FAILED,
			error,
		}
	},

	addActivity(topic = '') {
		return {
			type: actionTypes.ONBOARDING_ACTIVITY_ADD_ACTIVITY,
			topic,
		}
	},

	addActivityCancelled() {
		return {
			type: actionTypes.ONBOARDING_ACTIVITY_ADD_ACTIVITY_CANCELLED,
		}
	},

	addActivitySuccess() {
		return {
			type: actionTypes.ONBOARDING_ACTIVITY_ADD_ACTIVITY_SUCCESS,
		}
	},

	addActivityFailed(error) {
		return {
			type: actionTypes.ONBOARDING_ACTIVITY_ADD_ACTIVITY_FAILED,
			error,
		}
	},

	transitionAnimationCompleted() {
		return {
			type: actionTypes.ONBOARDING_ACTIVITY_TRANSITION_ANIMATION_COMPLETED,
		}
	},


	explainerCompleted() {
		return {
			type: actionTypes.ONBOARDING_ACTIVITY_EXPLAINER_COMPLETED,
		}
	},

	demoCardPosted(text) {
		return {
			type: actionTypes.ONBOARDING_ACTIVITY_DEMO_CARD_POSTED,
			text,
		}
	},

	demoCompleted() {
		return {
			type: actionTypes.ONBOARDING_ACTIVITY_DEMO_COMPLETED,
		}
	},
}

export default onboardingActivityActions
